import { GetterTree } from 'vuex';
import { EntityState, LayoutItem } from '@/store/entity/types';
import { RootState } from '@/store/types';
import {
  PimcoreEntityType,
  PimcoreEntityNavigation,
  PimcoreEntityLayout,
  PimcoreLayoutState, PimcoreLayoutInput, PimcoreLayoutPanel,
} from '@/types/entity';

const findEntityByName = (entities: PimcoreEntityType[], name: string) => entities.find((entityItem) => entityItem.name === name);

const findLayoutItem = (layouts: LayoutItem[], entity: string): PimcoreEntityLayout[] => {
  const entityLayoutItem = layouts.find((item: LayoutItem) => item.entity === entity);
  return entityLayoutItem?.layouts || [];
};

const findLayout = (layouts: LayoutItem[], entity: string, type: string): PimcoreEntityLayout|null => {
  const entityLayouts = findLayoutItem(layouts, entity);
  return entityLayouts.find((layout: PimcoreEntityLayout) => layout.description === type) || null;
};

const getters: GetterTree<EntityState, RootState> = {
  entitiesMap({ entities }): Array<PimcoreEntityNavigation> {
    return entities
      .filter((entity) => entity.name.includes('Listing'))
      .map((entity) => {
        const itemEntityName = entity.name.replace('Listing', '');
        const itemEntity = findEntityByName(entities, itemEntityName);
        return {
          name: entity.name,
          title: entity.name.replace('get', '').replace('Listing', ''),
          type: itemEntity ? itemEntity.type.name : entity.type.name,
        };
      });
  },
  entityListByTitle({ entities }) {
    return (title: string): PimcoreEntityType|null => {
      const currentEntity = entities.find((entity) => entity.name.includes(title) && entity.name.includes('Listing'));
      return currentEntity || null;
    };
  },
  entityByTitle({ entities }) {
    return (title: string): PimcoreEntityType|null => {
      const currentEntity = entities.find((entity) => entity.name.includes(title) && !entity.name.includes('Listing'));
      return currentEntity || null;
    };
  },
  /**
   * Функция возвращает макет по типу
   * <pre>
   * Пример использования:
   * this.layoutByType('Supplier', 'form') - layout формы
   * this.layoutByType('Supplier', 'profile') - layout формы личного кабинета поставщика
   * this.layoutByType('Supplier', 'grid') - layout грида сущности
   * </pre>
   * @param layouts - список макетов из состояния vuex
   */
  layoutByType({ layouts }): (entity: string, type: string) => PimcoreEntityLayout|null {
    return (entity: string, type: string) => findLayout(layouts, entity, type);
  },
  layoutFieldsByType({ layouts }): (entity: string, type: string) => Array<PimcoreLayoutPanel|PimcoreLayoutInput> {
    return (entity: string, type: string) => {
      const layout = findLayout(layouts, entity, type);
      return layout?.layoutDefinitions?.childs || [];
    };
  },
  /**
   * Функция возвращает поля макета сущности для таблицы списка сущностей
   */
  gridLayoutFields({ layouts }, getter): (entity: string) => PimcoreEntityLayout|null {
    return (entity: string) => getter.layoutFieldsByType(entity, 'grid');
  },
  /**
   * Функция проверяет загружены ли макеты
   * @param layoutClass - состояние загрузки макета
   */
  isLayoutLoading({ layoutClass }): boolean {
    return layoutClass === PimcoreLayoutState.initial
      || layoutClass === PimcoreLayoutState.loading;
  },
};

export default getters;
